// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"f_-z","disabled":"g_-z","label":"h_-z"};